<template>
    <v-dialog width="400px" persistent v-if="error" :value="hasError">
      <v-card>
        <v-card-text
          class="error--text headline font-weight-medium text-xs-center"
        >
          <span>{{ error.message }}</span>
        </v-card-text>
        <v-card-actions>
          <v-btn block flat color="secondary" @click="fecharDialogError"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  methods: {
    fecharDialogError () {
      this.$store.dispatch('setError', null)
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    hasError () {
      return !!this.$store.getters.error
    }
  }
}
</script>
